import React from 'react'


const upcomingEventApi = [
    {
        id:1,
        date:"01",
        month:"May",
        mainheading:"Ramadan is a holy month in the Islamic calendar, during which Muslims fast from dawn until sunset.",
        details:"Sit etiam sed egestas enim. Turpis sed ante facilisi sapien dictum. Ultrices elementum Sit etiam sed egestas enim",
        detailsbig:"Sit etiam sed egestas enim. Turpis sed ante facilisi sapien dictum. Ultrices elementum Sit etiam sed egestas enimSit etiam sed egestas enim. Turpis sed ante facilisi sapien dictum. Ultrices elementum Sit etiam sed egestas enimSit etiam sed egestas enim. Turpis sed ante facilisi sapien dictum. Ultrices elementum Sit etiam sed egestas enim"        ,
        readmoretext:"Read More"
    },
    {
        id:2,
        date:"02",
        month:"May",
        mainheading:"Eid al-Fitr is the celebration that marks the end of Ramadan. It is a time of feasting, gift-giving",
        details:"2 Sit etiam sed egestas enim. Turpis sed ante facilisi sapien dictum. Ultrices elementum Sit etiam sed egestas enim",
        detailsbig:"2 Sit etiam sed egestas enim. Turpis sed ante facilisi sapien dictum. Ultrices elementum Sit etiam sed egestas enimSit etiam sed egestas enim. Turpis sed ante facilisi sapien dictum. Ultrices elementum Sit etiam sed egestas enimSit etiam sed egestas enim. Turpis sed ante facilisi sapien dictum. Ultrices elementum Sit etiam sed egestas enim",
        readmoretext:"Read More"
    },
    {
        id:3,
        date:"13",
        month:"Aug",
        mainheading:"Hajj is an annual Islamic pilgrimage to Mecca that all able-bodied and financially capable Muslims are",
        details:"Sit etiam sed egestas enim. Turpis sed ante facilisi sapien dictum. Ultrices elementum Sit etiam sed egestas enim",
        detailsbig:"Sit etiam sed egestas enim. Turpis sed ante facilisi sapien dictum. Ultrices elementum Sit etiam sed egestas enimSit etiam sed egestas enim. Turpis sed ante facilisi sapien dictum. Ultrices elementum Sit etiam sed egestas enimSit etiam sed egestas enim. Turpis sed ante facilisi sapien dictum. Ultrices elementum Sit etiam sed egestas enim",
        readmoretext:"Read More"
    },
    {
        id:4,
        date:"31",
        month:"Aug",
        mainheading:"The Islamic New Year, also known as Hijri New Year, marks the beginning of the Islamic calendar.",
        details:"Sit etiam sed egestas enim. Turpis sed ante facilisi sapien dictum. Ultrices elementum Sit etiam sed egestas enim",
        detailsbig:"Sit etiam sed egestas enim. Turpis sed ante facilisi sapien dictum. Ultrices elementum Sit etiam sed egestas enimSit etiam sed egestas enim. Turpis sed ante facilisi sapien dictum. Ultrices elementum Sit etiam sed egestas enimSit etiam sed egestas enim. Turpis sed ante facilisi sapien dictum. Ultrices elementum Sit etiam sed egestas enim",
        readmoretext:"Read More"
    },
    {
        id:5,
        date:"31",
        month:"Aug",
        mainheading:"The Islamic New Year, also known as Hijri New Year, marks the beginning of the Islamic calendar.",
        details:"Sit etiam sed egestas enim. Turpis sed ante facilisi sapien dictum. Ultrices elementum Sit etiam sed egestas enim",
        detailsbig:"Sit etiam sed egestas enim. Turpis sed ante facilisi sapien dictum. Ultrices elementum Sit etiam sed egestas enimSit etiam sed egestas enim. Turpis sed ante facilisi sapien dictum. Ultrices elementum Sit etiam sed egestas enimSit etiam sed egestas enim. Turpis sed ante facilisi sapien dictum. Ultrices elementum Sit etiam sed egestas enim",
        readmoretext:"Read More"
    },
    {
        id:6,
        date:"31",
        month:"Aug",
        mainheading:"The Islamic New Year, also known as Hijri New Year, marks the beginning of the Islamic calendar.",
        details:"Sit etiam sed egestas enim. Turpis sed ante facilisi sapien dictum. Ultrices elementum Sit etiam sed egestas enim",
        detailsbig:"Sit etiam sed egestas enim. Turpis sed ante facilisi sapien dictum. Ultrices elementum Sit etiam sed egestas enimSit etiam sed egestas enim. Turpis sed ante facilisi sapien dictum. Ultrices elementum Sit etiam sed egestas enimSit etiam sed egestas enim. Turpis sed ante facilisi sapien dictum. Ultrices elementum Sit etiam sed egestas enim",
        readmoretext:"Read More"
    },
    {
        id:7,
        date:"31",
        month:"Aug",
        mainheading:"The Islamic New Year, also known as Hijri New Year, marks the beginning of the Islamic calendar.",
        details:"Sit etiam sed egestas enim. Turpis sed ante facilisi sapien dictum. Ultrices elementum Sit etiam sed egestas enim",
        detailsbig:"Sit etiam sed egestas enim. Turpis sed ante facilisi sapien dictum. Ultrices elementum Sit etiam sed egestas enimSit etiam sed egestas enim. Turpis sed ante facilisi sapien dictum. Ultrices elementum Sit etiam sed egestas enimSit etiam sed egestas enim. Turpis sed ante facilisi sapien dictum. Ultrices elementum Sit etiam sed egestas enim",
        readmoretext:"Read More"
    },
    {
        id:8,
        date:"31",
        month:"Aug",
        mainheading:"The Islamic New Year, also known as Hijri New Year, marks the beginning of the Islamic calendar.",
        details:"Sit etiam sed egestas enim. Turpis sed ante facilisi sapien dictum. Ultrices elementum Sit etiam sed egestas enim",
        detailsbig:"Sit etiam sed egestas enim. Turpis sed ante facilisi sapien dictum. Ultrices elementum Sit etiam sed egestas enimSit etiam sed egestas enim. Turpis sed ante facilisi sapien dictum. Ultrices elementum Sit etiam sed egestas enimSit etiam sed egestas enim. Turpis sed ante facilisi sapien dictum. Ultrices elementum Sit etiam sed egestas enim",
        readmoretext:"Read More"
    },
    
]

const UpcomingEventAPI = () => {
  return (
    <>
    
    </>
  )
}

export {upcomingEventApi}

export default UpcomingEventAPI